import FiguresTooltip from './FiguresTooltip';

export default FiguresTooltip;
